import * as React from 'react';
import { LoadingScreen } from '../LoadingScreen';
import { ErrorScreen } from '../ErrorScreen';
import { Card } from '../Card';
import * as style from './style.css';
import { jsx as _jsx } from "react/jsx-runtime";
export const LayoutsCards = _ref => {
  let {
    layouts,
    isLoading,
    isError,
    onLayoutCardClick,
    onReset,
    trackLayoutModalOpen,
    trackListingLinkClick,
    isLayoutModalDisabled
  } = _ref;
  if (isLoading) {
    return /*#__PURE__*/_jsx(LoadingScreen, {});
  }
  if (isError) {
    return /*#__PURE__*/_jsx(ErrorScreen, {
      onReset: onReset
    });
  }
  return /*#__PURE__*/_jsx("div", {
    className: style['cards-list'],
    children: layouts.map((layout, i) => /*#__PURE__*/_jsx(Card, {
      layout: layout,
      onClick: onLayoutCardClick,
      trackLayoutModalOpen: trackLayoutModalOpen,
      trackListingLinkClick: trackListingLinkClick,
      isLayoutModalDisabled: isLayoutModalDisabled
    }, i))
  });
};